import React from "react";
import PropTypes from "prop-types";

import { ErrorBoundaryClass } from "./components/ErrorBoundaryClass";
import { useStore } from "../../../../../stores/AppStore";

export const ErrorBoundary = (props) => {
  const { children } = props;

  const store = useStore();

  return (
    <ErrorBoundaryClass loggedUser={store.user.loggedInUser}>
      {children}
    </ErrorBoundaryClass>
  );
};

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};
